"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { scrimVariants } from "./Scrim.variants.js";
const Scrim_Scrim = /*#__PURE__*/ forwardRef(function({ children, className, isBottom = false, isTop = false, padding = 2, overhang, ...props }, ref) {
    const classes = cn(scrimVariants({
        padding,
        isTop,
        isBottom,
        isFull: !isTop && !isBottom,
        overhang
    }), className);
    return /*#__PURE__*/ jsx("div", {
        ref: ref,
        className: classes,
        ...props,
        children: children
    });
});
export { Scrim_Scrim as Scrim };
